import { render, staticRenderFns } from "./Advertisements.vue?vue&type=template&id=557b12f6&scoped=true"
import script from "./Advertisements.vue?vue&type=script&lang=js"
export * from "./Advertisements.vue?vue&type=script&lang=js"
import style0 from "./Advertisements.vue?vue&type=style&index=0&id=557b12f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557b12f6",
  null
  
)

export default component.exports